const constants = {
    API_SERVICE_HOST: "api.scrapingant.com",
    API_SERVICE_PATH: "/v2",
    GOOGLE_ANALYTICS_ID: "UA-162341230-1",
    GOOGLE_GLOBAL_TAG_ID: "G-1ZZGTD3KKH",
    GOOGLE_ADWORDS_TAG_ID: "AW-16560280692",
    GOOGLE_ADWORDS_CONVERSION_ID: "AW-16607384680/FgS9CLywibsZEOiogu89",
    GOOGLE_CLIENT_ID: "231613358720-oan6disgba9b1c2kqmvnujkrhuo8islq.apps.googleusercontent.com",
    RECAPTCHA_SITE_KEY: "6LekbYgiAAAAAB8-nQKo9jjBcDsyYJcnteyK9tVd",
    TEXT: {
        DEFAULT_TITLE: "ScrapingAnt User Panel"
    },
    PADDLE_VENDOR_ID: 123817,
    DEFAULT_REQUEST_GENERATOR_SITE: "https://example.com",
    SENTRY_DSN: "https://1bdea8fd573a4415b78f62a3bbc8425a@o557406.ingest.sentry.io/5689604",

    ANALYTICS_EVENTS: {
        LOGIN: 'login',
        SIGN_UP: 'sign_up',
        CHECK_OUT: 'check_out',
        CHECK_OUT_SUCCESS: 'check_out_success',
        CHECK_OUT_CANCELLED: 'check_out_cancelled',
        CANCEL_SUCCESS: 'cancel_success',
        CANCEL_CANCELLED: 'cancel_cancelled',
        RESEND_EMAIL: 'resend_email',
        EXECUTE_REQUEST: 'execute_request',

        PAYMENT_CATEGORY: 'payment',
        DEFAULT_CATEGORY: 'engagement',
    },
    RANDOM_STRINGS_TO_ENDORSE_DOCUMENTATION_READING: [
        {
            "title": "Unlock the Full Potential",
            "content": "Discover all the features and capabilities of our web scraping API in the documentation. It's packed with tips and best practices to help you get the most out of our service!",
            "icon": "mdi-lock-open"
        },
        {
            "title": "Save Time with Tips",
            "content": "Check out the documentation for time-saving tips and tricks. Whether you're a beginner or an expert, there's always something new to learn!",
            "icon": "mdi-clock"
        },
        {
            "title": "Maximize Efficiency",
            "content": "Learn how to optimize your scraping tasks and handle data more efficiently. Our documentation provides detailed examples and guidance.",
            "icon": "mdi-speedometer"
        },
        {
            "title": "Stay Up-to-Date",
            "content": "Our documentation is constantly updated with the latest features and improvements. Make sure you’re taking advantage of all the new functionalities!",
            "icon": "mdi-update"
        },
        {
            "title": "Troubleshoot with Ease",
            "content": "Encountering an issue? The documentation has comprehensive troubleshooting guides to help you solve problems quickly and effectively.",
            "icon": "mdi-alert-circle"
        },
        {
            "title": "Boost Your Skills",
            "content": "Enhance your web scraping skills with our detailed documentation. Perfect for all experience levels!",
            "icon": "mdi-school"
        },
        {
            "title": "Comprehensive Guides",
            "content": "Our documentation offers comprehensive guides to help you navigate and utilize all the features of our API.",
            "icon": "mdi-book-open-page-variant"
        },
        {
            "title": "Step-by-Step Tutorials",
            "content": "Follow our step-by-step tutorials in the documentation to get started quickly and efficiently.",
            "icon": "mdi-walk"
        },
        {
            "title": "Advanced Techniques",
            "content": "Learn advanced web scraping techniques to handle complex tasks. Our documentation covers it all.",
            "icon": "mdi-brain"
        },
        {
            "title": "Community Support",
            "content": "Join our community and get support from other users. Find more information in the documentation.",
            "icon": "mdi-account-group"
        },
        {
            "title": "API Reference",
            "content": "Access our complete API reference in the documentation for detailed information on every endpoint.",
            "icon": "mdi-file-document"
        },
        {
            "title": "Real-World Examples",
            "content": "See real-world examples of how to use our API in the documentation. Get inspired and get started!",
            "icon": "mdi-lightbulb"
        },
        {
            "title": "Performance Tips",
            "content": "Optimize your web scraping performance with the tips and tricks found in our documentation.",
            "icon": "mdi-rocket"
        },
        {
            "title": "Security Best Practices",
            "content": "Learn about the best practices for secure web scraping in our comprehensive documentation.",
            "icon": "mdi-shield-lock"
        },
        {
            "title": "Integration Guides",
            "content": "Find detailed guides on integrating our API with various tools and platforms in the documentation.",
            "icon": "mdi-link"
        },
        {
            "title": "Error Handling",
            "content": "Understand how to handle errors effectively with the guidance provided in our documentation.",
            "icon": "mdi-alert"
        },
        {
            "title": "Data Processing",
            "content": "Learn how to process and clean your scraped data with our detailed documentation.",
            "icon": "mdi-database"
        },
        {
            "title": "Customization Options",
            "content": "Explore the customization options available in our API through the documentation.",
            "icon": "mdi-cogs"
        },
        {
            "title": "User-Friendly Examples",
            "content": "Our documentation is filled with user-friendly examples to help you get the most out of our API.",
            "icon": "mdi-handshake"
        },
        {
            "title": "Regular Updates",
            "content": "Stay informed about regular updates and new features by checking the documentation frequently.",
            "icon": "mdi-refresh"
        },
        {
            "title": "Code Snippets",
            "content": "Utilize the ready-to-use code snippets available in our documentation to speed up your development.",
            "icon": "mdi-code-tags"
        },
        {
            "title": "User Feedback",
            "content": "Read feedback from other users and learn from their experiences in our documentation.",
            "icon": "mdi-comment-multiple"
        },
        {
            "title": "Quick Start Guide",
            "content": "Get up and running quickly with our Quick Start Guide in the documentation.",
            "icon": "mdi-rocket-launch"
        },
        {
            "title": "API Limits",
            "content": "Understand the API limits and how to manage them by reading our documentation.",
            "icon": "mdi-speedometer-medium"
        },
        {
            "title": "Data Export",
            "content": "Learn how to export your scraped data in various formats through our documentation.",
            "icon": "mdi-export"
        },
        {
            "title": "Versioning Information",
            "content": "Stay informed about different versions of our API and their features by checking the documentation.",
            "icon": "mdi-timeline-clock"
        },
        {
            "title": "Environment Setup",
            "content": "Set up your development environment with ease using the setup guides in our documentation.",
            "icon": "mdi-desktop-classic"
        },
        {
            "title": "Best Practices",
            "content": "Follow the best practices outlined in our documentation to ensure efficient and effective scraping.",
            "icon": "mdi-check-circle"
        },
        {
            "title": "Multi-Language Support",
            "content": "Our documentation supports multiple programming languages. Find examples in your preferred language.",
            "icon": "mdi-translate"
        },
        {
            "title": "Detailed API Specs",
            "content": "Access detailed specifications for each API endpoint in the documentation.",
            "icon": "mdi-file-chart"
        }
    ],
    RANDOM_STRINGS_TO_ENDORSE_DOCUMENTATION_READING_RESIDENTIAL: [
        {
            "title": "Understand Residential Proxies",
            "content": "Learn the basics and benefits of using residential proxies in our detailed documentation.",
            "icon": "mdi-home-account"
        },
        {
            "title": "Setup Guides",
            "content": "Follow our step-by-step setup guides to start using residential proxies efficiently.",
            "icon": "mdi-cog"
        },
        {
            "title": "Usage Best Practices",
            "content": "Discover best practices for using residential proxies to ensure optimal performance.",
            "icon": "mdi-thumb-up"
        },
        {
            "title": "Troubleshooting Tips",
            "content": "Encountering issues? Our documentation provides troubleshooting tips to resolve common problems.",
            "icon": "mdi-wrench"
        },
        {
            "title": "Maximize Anonymity",
            "content": "Learn how to maximize your anonymity and security when using residential proxies.",
            "icon": "mdi-shield"
        },
        {
            "title": "Integration Examples",
            "content": "Find examples of how to integrate residential proxies with various applications and tools.",
            "icon": "mdi-puzzle"
        },
        {
            "title": "Performance Optimization",
            "content": "Optimize the performance of your residential proxies with tips from our documentation.",
            "icon": "mdi-speedometer"
        },
        {
            "title": "Advanced Configurations",
            "content": "Explore advanced configuration options to tailor residential proxies to your specific needs.",
            "icon": "mdi-tune"
        },
        {
            "title": "API Reference",
            "content": "Access the complete API reference for residential proxies in our documentation.",
            "icon": "mdi-book-open"
        },
        {
            "title": "Regular Updates",
            "content": "Stay informed about the latest updates and features for residential proxies by checking the documentation.",
            "icon": "mdi-update"
        }
    ],
    RANDOM_STRINGS_TO_ENDORSE_DOCUMENTATION_READING_DATACENTER: [
        {
            "title": "Understand Datacenter Proxies",
            "content": "Explore the fundamentals and advantages of datacenter proxies in our comprehensive documentation.",
            "icon": "mdi-server"
        },
        {
            "title": "Quick Start Guide",
            "content": "Get started quickly with our easy-to-follow datacenter proxy setup and configuration guides.",
            "icon": "mdi-rocket"
        },
        {
            "title": "Performance Guidelines",
            "content": "Learn how to achieve maximum speed and reliability with datacenter proxies using our best practices.",
            "icon": "mdi-flash"
        },
        {
            "title": "Problem Resolution",
            "content": "Find solutions to common datacenter proxy issues with our detailed troubleshooting guide.",
            "icon": "mdi-help-circle"
        },
        {
            "title": "Security Measures",
            "content": "Implement robust security practices for your datacenter proxies using our security recommendations.",
            "icon": "mdi-lock"
        },
        {
            "title": "System Integration",
            "content": "Learn how to integrate datacenter proxies with your existing infrastructure and applications.",
            "icon": "mdi-connection"
        },
        {
            "title": "Load Balancing",
            "content": "Optimize proxy distribution and handle high traffic loads with our load balancing strategies.",
            "icon": "mdi-swap-horizontal"
        },
        {
            "title": "Enterprise Setup",
            "content": "Configure enterprise-grade datacenter proxy networks with advanced routing and failover options.",
            "icon": "mdi-office-building"
        },
        {
            "title": "API Documentation",
            "content": "Access comprehensive API documentation for programmatic control of your datacenter proxies.",
            "icon": "mdi-api"
        },
        {
            "title": "Changelog",
            "content": "Keep track of new features, improvements, and updates to our datacenter proxy service.",
            "icon": "mdi-history"
        }
    ]
}

export default constants
